import React from 'react';

// 배경 있는 버전 (외부 호스팅 mp4)
const BG_VIDEO_SRC =
  'https://file.fnf.co.kr/2026-01-16/DqvBjHN1RXHQ1rrE8EPzQFJ6G9PnFqh18gwsNhVE.mp4';

// 배경 없는(투명/alpha) 버전 — Safari는 HEVC(.mov), Chrome/FF는 VP9(.webm)
// TODO: mp4처럼 외부(file.fnf.co.kr) 호스팅으로 옮기면 아래 두 상수만 교체
const ALPHA_HEVC_SRC = '/videos/document-avatar-alpha.mov';
const ALPHA_WEBM_SRC = '/videos/document-avatar-alpha.webm';

const DocumentAgentIcon = (props: {
  width?: number | string;
  height?: number | string;
  /** 배경 없는 투명(alpha) 버전으로 렌더 (기본: 배경 있는 mp4) */
  transparent?: boolean;
}) => {
  const width = props.width
    ? typeof props.width === 'number'
      ? `${props.width}px`
      : props.width
    : 'auto';

  const height = props.height
    ? typeof props.height === 'number'
      ? `${props.height}px`
      : props.height
    : 'auto';

  return (
    <video
      autoPlay
      loop
      muted
      playsInline
      controls={false}
      disablePictureInPicture
      controlsList="nodownload nofullscreen noplaybackrate"
      aria-hidden="true"
      style={{ width, height }}
    >
      {props.transparent ? (
        <>
          {/* Safari: HEVC alpha (.mov) 우선 — Chrome/FF는 디코딩 불가라 건너뜀 */}
          <source src={ALPHA_HEVC_SRC} type="video/quicktime" />
          {/* Chrome/Firefox: VP9 alpha (.webm) */}
          <source src={ALPHA_WEBM_SRC} type="video/webm" />
        </>
      ) : (
        <source src={BG_VIDEO_SRC} type="video/mp4" />
      )}
      브라우저가 비디오 요소를 지원하지 않습니다.
    </video>
  );
};

export default DocumentAgentIcon;
